import { MODAL_REQUEST } from './constants';

const INITIAL_STATE = {
  currentModal: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_REQUEST: {
      return {
        ...state,
        currentModal: action.modal
      };
    }
    default:
      return state;
  }
};

export default reducer;
